export default __webpack_public_path__ + "static/media/hamburger.a1ff3b42.svg";